import { useSetAtom } from 'jotai';
import { domain } from 'modules/data';
import { useCallback } from 'react';

import { CustomFieldsState } from '../../data/types';
import { netSuiteCustomFieldsState } from '../../resources/states';
import { CustomFieldChangeHandler } from './useCustomFields.types';

export const useCustomFields = (customFieldList: domain.Field[]) => {
    const setCustomFieldsValues = useSetAtom(netSuiteCustomFieldsState);

    const onCustomFieldChange = useCallback<CustomFieldChangeHandler>(
        (fieldId, valueKey, value) => {
            setCustomFieldsValues((current) => {
                const newValues = { ...current };

                if (newValues[fieldId]) {
                    newValues[fieldId] = {
                        ...newValues[fieldId],
                        [valueKey]: value,
                    };
                } else {
                    const referenceField = customFieldList.find((field) => {
                        return field.id === fieldId;
                    });

                    if (referenceField && referenceField.netSuiteField) {
                        newValues[fieldId] = {
                            companyFieldId: fieldId,
                            scriptId: referenceField.netSuiteField.fieldScriptId,
                            internalId: referenceField.netSuiteField.id,
                            fieldType: referenceField.netSuiteField.type || '',
                            valueString: null,
                            valueRef: null,
                            valueRefs: null,
                            valueBoolean: null,
                            valueDate: null,
                            valueDecimal: null,
                            valueLong: null,
                            [valueKey]: value,
                        };
                    }
                }

                return newValues;
            });
        },
        [customFieldList, setCustomFieldsValues]
    );

    const setCustomFieldValuesBulk = useCallback(
        (values: CustomFieldsState) => {
            setCustomFieldsValues(values);
        },
        [setCustomFieldsValues]
    );

    return {
        onCustomFieldChange,
        setCustomFieldValuesBulk,
    };
};
